import axios from 'axios';

// Shared axios instance for client services that expect './api'
// Base URL points to Express server in dev (CRA proxy also handles /api),
// and uses relative path in production where the server serves the client.
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '' : '',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to ensure proper headers for CSRF protection
api.interceptors.request.use(
  (config) => {
    // Set proper origin header for CSRF protection
    if (process.env.NODE_ENV === 'development') {
      config.headers['Origin'] = 'http://localhost:3000';
    }

    // Note: Referer header is automatically set by the browser and cannot be set manually

    // Remove Content-Type header for DELETE requests without a body
    // This prevents Express body-parser from attempting to parse an empty JSON body
    // which can cause 400 Bad Request errors
    if (config.method === 'delete' && !config.data) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for better error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.error === 'CSRF protection') {
      console.warn('CSRF protection triggered, retrying with proper headers');
      // The request will be retried automatically with the proper headers from the request interceptor
    }
    return Promise.reject(error);
  }
);

export default api;
